"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBox = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../theme/colors");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var message_box_1 = require("../message-box");
var padding_1 = require("../padding");
var stack_1 = require("../stack");
var text_1 = require("../text");
var VariantIcon = function (_a) {
    var variant = _a.variant, isDoubleSuccess = _a.isDoubleSuccess;
    switch (variant) {
        case 'alert':
            return react_1.default.createElement(icons_1.IconWarning, { color: colors_1.colors.fire[500] });
        case 'success':
            if (isDoubleSuccess) {
                return (react_1.default.createElement(stack_1.Stack, { direction: "horizontal", gap: 0 },
                    react_1.default.createElement(icons_1.IconDoubleTick, { size: 24, color: colors_1.colors.grass[500] })));
            }
            return react_1.default.createElement(icons_1.IconTick, { size: 16, color: colors_1.colors.grass[500] });
        case 'neutral':
            return react_1.default.createElement(icons_1.IconCalendar, { color: colors_1.colors.brand[300], size: 20 });
        case 'warning':
            return react_1.default.createElement(icons_1.IconWarning, { color: colors_1.colors.peach[500] });
        case 'disabled':
            return react_1.default.createElement(icons_1.IconCross, null);
        default:
            return null;
    }
};
function StatusBox(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'success' : _b, message = _a.message, action = _a.action, prewrap = _a.prewrap, _c = _a.borderless, borderless = _c === void 0 ? true : _c, _d = _a.hasBorderRadius, hasBorderRadius = _d === void 0 ? true : _d, _e = _a.isDoubleSuccess, isDoubleSuccess = _e === void 0 ? false : _e;
    return (react_1.default.createElement(message_box_1.StyledMessageBox, { variant: variant, "data-testid": "root", borderless: borderless, hasBorderRadius: hasBorderRadius },
        react_1.default.createElement(padding_1.Padding, { size: 8 },
            react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center", justifyContent: "center" },
                react_1.default.createElement(flexbox_1.FlexCell, null,
                    react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
                        react_1.default.createElement(flexbox_1.FlexCell, { flex: "none" },
                            react_1.default.createElement(padding_1.Padding, { right: 8, top: variant === 'alert' || variant === 'warning' || variant === 'disabled' ? 4 : 0 },
                                react_1.default.createElement(VariantIcon, { variant: variant, isDoubleSuccess: isDoubleSuccess }))),
                        react_1.default.createElement(flexbox_1.FlexCell, null,
                            react_1.default.createElement(text_1.Text, { color: message_box_1.variantColors[variant].color, prewrap: prewrap }, message)),
                        action && (react_1.default.createElement(flexbox_1.FlexCell, null,
                            react_1.default.createElement(padding_1.Padding, { x: 4 },
                                react_1.default.createElement(text_1.Text, { color: message_box_1.variantColors[variant].color },
                                    react_1.default.createElement(StyledLearnMoreButton, { type: "button", onClick: action.onClick, variant: variant },
                                        react_1.default.createElement(text_1.Text, { weight: 600, color: message_box_1.variantColors[variant].color }, action.text))))))))))));
}
exports.StatusBox = StatusBox;
var StyledLearnMoreButton = styled_components_1.default.button(function (_a) {
    var variant = _a.variant;
    return "\n  background: none;\n  padding: 0.125rem;\n  margin: 0;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline ".concat(message_box_1.variantColors[variant].color, ";\n\n  &:focus,\n  &:active {\n    outline-color: ").concat(colors_1.colors.fire[400], ";\n  }\n");
});
//# sourceMappingURL=index.js.map